import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  standalone: false,
})
export class LoadingSpinnerComponent {
  diameter: number | undefined;
  mode: 'indeterminate' | 'determinate' = 'indeterminate';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      mode: 'indeterminate' | 'determinate';
      diameter: number;
    },
  ) {}

  ngOnInit() {
    this.mode = this.data.mode;
    this.diameter = this.data.diameter;
  }
}
